<div class="dealer-location-wrapper">  
  <div class="locations-container">
    <div class="header-section">
    <div class="page-header">Online Appointment Booking</div>
    </div>
    <div class="locations-header">
      @if (isComponentReady) {
      <h3 i18n>Select dealer outlet</h3>
      <p i18n>Here are the list of outlets for your booking. Please select from current available options.</p>
      } @else {
      <h3>&nbsp;</h3>
      <p>&nbsp;</p>
      }

      <div class="view-toggle">
        @if (isComponentReady) {
        <span i18n> Map view</span>
        <mat-slide-toggle class="toggle" [(ngModel)]="showMapView" (change)="onToggleChange($event)"
          [disabled]="!hasValidLocations()">
        </mat-slide-toggle>
        } @else {
        <span>&nbsp;</span>
        }
      </div>
    </div>

    <div class="scrollable-content">
      @if (!loader) {
      @if (!showMapView) {
      @for (loc of locations; track loc.id) {
      <mat-card class="location-card" (click)="selectDealerFromTile(loc)" [ngClass]="{ 'selected': isSelected(loc) }">
        <mat-card-header>
          <mat-card-title>{{ loc.Name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ loc.Address }}</p>
        </mat-card-content>
      </mat-card>
      }
      }

      @if (showMapView && hasValidLocations()) {
      <!-- OpenStreetMap Container -->
      <div class="map-section">
        <div id="dealer-map" class="dealer-map"></div>
      </div>
      @if (!loader && locations.length > 0) {
      <div class="continue-button-container">
        <button mat-raised-button class="custom-continue-button" [disabled]="!selectedDealer"
          (click)="onContinueClick()">
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      }
      }
      } @else if (!loader && hasNoLocations()) {
      <div class="no-locations-message">
        <div class="no-map-placeholder">
          <img src="assets/common/search_off.svg" alt="No locations found" class="no-locations-icon" />
          @if (isComponentReady) {
          <h3 i18n>No results found</h3>
          <p i18n>There are no service centers available for this code. Enter another code.</p>
          } @else {
          <h3>&nbsp;</h3>
          <p>&nbsp;</p>
          }
        </div>
      </div>
      }     
    </div>    
  </div>
   <div class="content-divider">
        Powered by incadea
    </div>
</div>